import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'child-cell',
  template: `
  <button class="btn btn-sm bg-dark" (click)="invokeParentMethod()">View</button>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
        // margin-bottom: 5px;
      }
    `,
  ],
})
export class ViewRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.params.data['action'] = 'view';
    this.params.context.componentParent.methodFromParent(
        this.params.data
    );
  }

  refresh(): boolean {
    return false;
  }
}